import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ProjectDetailTabKeys,
  ProjectFinancialsContractType,
  tabApiEnumMap,
} from 'api/project';
import { Visibility, VisibilityMeta } from 'api/visibility';
import { IconShell } from 'components/atoms/icon-shell';
import { useFeatureEnabledProjectTabs } from 'components/molecules/project-details/hooks';
import { CheckboxGroup, Helptext, Label } from './styled';

const getIcon = (IconEl) => {
  return IconEl ? <IconEl /> : null;
};

const tabVisibilityFallback = {
  overview: false,
  financials: false,
  projectPlan: false,
  spaces: false,
  chat: false,
  statusUpdates: false,
  list: false,
  board: false,
  form: false,
  files: false,
};

interface Props {
  financialContractType?: ProjectFinancialsContractType;
  config: Visibility | undefined;
  onOptionChange: (payload: VisibilityMeta) => void;
}
export const VisibilityOptions: FC<Props> = ({
  financialContractType,
  config,
  onOptionChange,
}) => {
  const featureEnabledprojectTabs = useFeatureEnabledProjectTabs(
    financialContractType,
  );

  const alwaysVisibleTabs = [
    ProjectDetailTabKeys.Plan,
    ProjectDetailTabKeys.Spaces,
    ProjectDetailTabKeys.TaskList,
  ];

  const onChange = (values) => {
    const payload = values.reduce(
      (acc, item) => {
        acc[tabApiEnumMap[item]] = true;

        return acc;
      },
      { ...tabVisibilityFallback },
    );

    onOptionChange(payload as VisibilityMeta);
  };

  const projectTabs = featureEnabledprojectTabs
    .filter((tab) =>
      config ? config.visibilityMeta?.[tabApiEnumMap[tab.id]] : true,
    )
    .map((tab) => tab.id);
  const projectOptions = featureEnabledprojectTabs.map((tab) => {
    const isInternal: boolean = tab.id === ProjectDetailTabKeys.Financials;

    return {
      label: (
        <Label>
          <IconShell icon={getIcon(tab.icon)} />
          <div>
            {tab.id === ProjectDetailTabKeys.Overview ? (
              <>
                <FormattedMessage id="projects.tabs.overview_customer" />
                <Helptext className="visibility-option__info">
                  <FormattedMessage id="settings.project_tabs.tab.overview.help" />
                </Helptext>
              </>
            ) : (
              <FormattedMessage id={tab.translationKey} />
            )}
          </div>
        </Label>
      ),
      value: tab.id,
      disabled: alwaysVisibleTabs.includes(tab.id),
      style: isInternal
        ? {
            backgroundColor: 'var(--private-01)',
            margin:
              '0 calc(-1  * var(--spacing-03)) 0 calc(-1  * var(--spacing-03))',
            padding: '0 var(--spacing-02) 0 var(--spacing-03)',
            boxSizing: 'border-box' as React.CSSProperties['boxSizing'],
          }
        : {},
    };
  });

  return (
    <CheckboxGroup
      style={{ width: '100%' }}
      onChange={onChange}
      options={projectOptions}
      defaultValue={projectTabs}
    />
  );
};
